import { html, KompisElement } from '@inter-ikea-kompis/web-component';
/**
 * Popover class.
 */
export default class PopoverPosition extends KompisElement {
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        return html `
			<style>
				:host {
					display: inline-flex;
					position: relative;
				}
				::slotted(kompis-popover) {
					position: absolute;
					left: 0;
					right: 0;
					top: 0;
					bottom: 0;
					pointer-events: none;
				}
			</style>
			<slot></slot>
		`;
    }
}
//# sourceMappingURL=PopoverPosition.js.map